{
  "updatedOn": "Dernière mise à jour : {{date}}",
  "nav": {
    "notice": "Mentions légales",
    "privacy": "Confidentialité",
    "terms": "Conditions d'utilisation"
  },
  "notice": {
    "title": "Mentions légales",
    "updated": "2026-09-03",
    "pending": "Cette page n'est pas complète : la raison sociale de l'éditeur, son adresse, son numéro d'immatriculation, le nom du directeur de la publication et les coordonnées de l'hébergeur doivent être renseignés par l'exploitant avant toute ouverture au public. Ces informations ne figurent pas dans le code et ne peuvent pas en être déduites.",
    "sections": [
      {
        "heading": "Éditeur du site",
        "paragraphs": [
          "[Raison sociale] — [forme juridique] au capital de [montant].",
          "Siège social : [adresse postale complète].",
          "Immatriculation : [RCS / SIREN]. Numéro de TVA intracommunautaire : [numéro].",
          "Directeur de la publication : [nom et qualité].",
          "Contact : [adresse électronique de contact]."
        ]
      },
      {
        "heading": "Hébergement",
        "paragraphs": [
          "[Nom de l'hébergeur] — [adresse postale] — [téléphone].",
          "Les données sont hébergées dans l'Union européenne."
        ]
      },
      {
        "heading": "Propriété intellectuelle",
        "paragraphs": [
          "Les cours, leçons, exercices et ressources publiés sur la plateforme restent la propriété de leurs auteurs. La plateforme n'acquiert aucun droit de propriété sur ces contenus ; elle en assure l'hébergement et la diffusion aux personnes inscrites.",
          "Les marques, logos et éléments d'interface de la plateforme sont protégés et ne peuvent être reproduits sans autorisation écrite de l'éditeur."
        ]
      },
      {
        "heading": "Signalement d'un contenu",
        "paragraphs": [
          "Tout contenu peut être signalé depuis l'interface. Les signalements sont examinés par l'équipe de modération, qui peut rejeter le signalement, avertir l'auteur, masquer le contenu ou suspendre le compte concerné."
        ]
      }
    ]
  },
  "privacy": {
    "title": "Politique de confidentialité",
    "updated": "2026-09-03",
    "pending": "L'identité du responsable de traitement, les coordonnées du délégué à la protection des données le cas échéant, et le registre des sous-traitants doivent être complétés par l'exploitant. Ce document décrit fidèlement ce que le système fait des données ; il doit néanmoins être relu par un professionnel du droit avant toute ouverture au public, en particulier si des mineurs sont concernés.",
    "sections": [
      {
        "heading": "Ce que nous collectons",
        "paragraphs": [
          "À la création du compte : adresse électronique, nom et prénom. Ce sont les seules données obligatoires.",
          "Facultativement, si vous les renseignez : une présentation, une biographie, les matières et langues que vous enseignez ou apprenez, un fuseau horaire et une langue d'affichage.",
          "Du fait de votre usage : vos inscriptions à des cours, votre avancement, vos copies et leurs notes, vos messages, les fichiers que vous déposez, et les dates de vos connexions.",
          "Techniquement : l'adresse IP et l'identifiant de session sont consignés au journal de sécurité pour détecter les abus."
        ]
      },
      {
        "heading": "Pourquoi",
        "paragraphs": [
          "Fournir le service : tenir votre compte, servir les cours auxquels vous êtes inscrit, calculer votre avancement, transmettre vos copies à votre enseignant, délivrer vos attestations.",
          "Assurer la sécurité : détecter les connexions anormales, les réutilisations de jeton et les abus, et conserver la trace des actions d'administration.",
          "Vous informer : notifications dans l'application et par courriel, dont vous réglez le détail dans vos préférences. Les avis strictement transactionnels — vérification d'adresse, changement de mot de passe, avertissement de modération, remise d'une attestation — ne se désactivent pas."
        ]
      },
      {
        "heading": "Le partage de votre progression",
        "paragraphs": [
          "Votre enseignant voit votre avancement dans ses cours si vous y consentez. Ce consentement est explicite, se retire à tout moment depuis vos préférences, et chaque changement est daté au journal.",
          "Vos coordonnées ne sont jamais transmises aux autres modules de la plateforme : un enseignant voit un nom d'affichage, pas une adresse électronique."
        ]
      },
      {
        "heading": "Combien de temps",
        "paragraphs": [
          "Journaux techniques : 90 jours. Journal d'audit : 3 ans. Messages : 3 ans. Comptes inactifs depuis 3 ans : anonymisation.",
          "Les notifications lues sont purgées au bout de 90 jours."
        ]
      },
      {
        "heading": "Vos droits",
        "paragraphs": [
          "Accès et portabilité : depuis votre compte, vous exportez à tout moment une archive structurée contenant votre compte, votre profil, vos préférences, vos rôles, vos sessions et l'historique daté de vos consentements.",
          "Effacement : depuis votre compte également. La suppression est programmée à 30 jours — ce délai est un droit de rétractation, pendant lequel le compte reste utilisable et la demande annulable. Passé ce délai, vos données identifiantes sont remplacées : votre nom devient « Utilisateur supprimé » et votre adresse une adresse technique.",
          "Ces deux gestes exigent de saisir à nouveau votre mot de passe : ce sont les deux actions qu'un accès volé rendrait irréparables.",
          "Rectification : vos profil et préférences se modifient à tout moment depuis votre compte."
        ]
      },
      {
        "heading": "Ce que l'effacement ne supprime pas",
        "paragraphs": [
          "Les données agrégées — le nombre d'inscrits d'un cours, les statistiques d'usage — sont conservées : elles ne vous concernent plus une fois anonymisées.",
          "Les attestations déjà délivrées restent valides et vérifiables, mais ne désignent plus personne : le nom qu'elles portent est relu à chaque impression, et devient anonyme avec le compte.",
          "Le journal d'audit n'est pas modifié. Il ne contient que des identifiants techniques, que l'anonymisation rend impossibles à rattacher à une personne, et il est la seule preuve qui subsiste que l'effacement a bien été demandé."
        ]
      },
      {
        "heading": "Mineurs",
        "paragraphs": [
          "Le consentement d'un titulaire de l'autorité parentale est requis en dessous de 15 ans."
        ]
      },
      {
        "heading": "Sous-traitants et localisation",
        "paragraphs": [
          "L'hébergement, l'envoi des courriels et le stockage des fichiers sont assurés par des prestataires dont la liste est tenue à jour par l'éditeur : [registre des sous-traitants].",
          "L'ensemble des données est hébergé dans l'Union européenne."
        ]
      },
      {
        "heading": "Nous contacter",
        "paragraphs": [
          "Pour toute question relative à vos données : [adresse électronique du responsable de traitement]."
        ]
      }
    ]
  },
  "terms": {
    "title": "Conditions générales d'utilisation",
    "updated": "2026-09-03",
    "pending": "Le droit applicable, la juridiction compétente, les conditions tarifaires détaillées et les clauses de responsabilité doivent être complétés et relus par un professionnel du droit avant toute ouverture au public.",
    "sections": [
      {
        "heading": "Objet",
        "paragraphs": [
          "Les présentes conditions régissent l'accès à la plateforme et son usage. Créer un compte vaut acceptation."
        ]
      },
      {
        "heading": "Votre compte",
        "paragraphs": [
          "Un compte est personnel. Vous êtes responsable de la confidentialité de votre mot de passe et des actions faites depuis vos sessions, que vous pouvez consulter et fermer à tout moment depuis votre compte.",
          "L'adresse électronique doit être vérifiée pour publier, envoyer une copie ou écrire un message. La lecture reste ouverte avant vérification."
        ]
      },
      {
        "heading": "Contenus et comportement",
        "paragraphs": [
          "Vous conservez la propriété de ce que vous publiez et nous accordez le droit de l'héberger et de le diffuser aux personnes autorisées à le voir.",
          "Sont interdits : les contenus illicites, la publication de données personnelles de tiers, le harcèlement, l'usurpation d'identité et l'usage automatisé destiné à contourner les limites du service.",
          "Tout contenu peut être signalé. Un modérateur peut alors consulter le contenu signalé et son contexte immédiat, dans les 72 heures suivant le signalement et seulement dans ce délai ; chaque consultation est enregistrée nominativement. Il peut rejeter le signalement, vous avertir, masquer le contenu ou suspendre votre compte."
        ]
      },
      {
        "heading": "Cours, progression et attestations",
        "paragraphs": [
          "L'accès aux leçons peut être conditionné à la réussite d'exercices, à la discrétion de l'enseignant qui a construit le cours.",
          "Une attestation est délivrée automatiquement à la complétion intégrale d'un cours, une seule fois, si l'offre de l'enseignant le prévoit. Elle porte un numéro que quiconque peut vérifier publiquement, sans compte.",
          "Une attestation peut être retirée par l'enseignant du cours, avec un motif. Elle reste alors vérifiable et la page de vérification indique qu'elle a été retirée."
        ]
      },
      {
        "heading": "Offres et abonnements",
        "paragraphs": [
          "Certaines capacités dépendent de l'offre souscrite par l'enseignant : nombre de cours publiables, nombre d'élèves, volume de stockage, délivrance d'attestations.",
          "Les conditions tarifaires, la durée d'engagement et les modalités de résiliation sont détaillées à la souscription : [conditions tarifaires]."
        ]
      },
      {
        "heading": "Disponibilité",
        "paragraphs": [
          "Le service est fourni sans garantie de disponibilité ininterrompue. Certaines fonctionnalités peuvent être temporairement fermées pour des raisons de sécurité ou d'exploitation ; l'interface l'indique alors explicitement."
        ]
      },
      {
        "heading": "Suspension et résiliation",
        "paragraphs": [
          "Un compte peut être suspendu en cas de manquement aux présentes conditions. La suspension est motivée et consignée.",
          "Vous pouvez supprimer votre compte à tout moment depuis votre espace ; les modalités et les délais sont décrits dans la politique de confidentialité."
        ]
      },
      {
        "heading": "Droit applicable",
        "paragraphs": ["[Droit applicable] — [juridiction compétente]."]
      }
    ]
  }
}
